import { render, staticRenderFns } from "./swipitem.vue?vue&type=template&id=de72f1ee"
import script from "./swipitem.vue?vue&type=script&lang=js"
export * from "./swipitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports